import { EventModule } from "app/event/EventModule"
import { FORM_EVENTS, IForm, IFormEventModule, IGeoTargetChangeParams } from "./model"

class FormEventModule extends EventModule implements IFormEventModule {
  public on = {
    sspSelectionChanged: (listenerId: string, fn: (newSelection: number[]) => void): void => {
      this.addListenerFn(FORM_EVENTS.SSP_SELECTION_CHANGED, listenerId, fn)
    },
    environmentsSelectionChanged: (listenerId: string, fn: (newSelection: number[]) => void): void => {
      this.addListenerFn(FORM_EVENTS.ENVIRONMENTS_SELECTION_CHANGED, listenerId, fn)
    },
    formCleared: (listenerId: string, fn: (oldForm: IForm) => void): void => {
      this.addListenerFn(FORM_EVENTS.FORM_CLEARED, listenerId, fn)
    },
    geoTargetChange: (listenerId: string, fn: (params: IGeoTargetChangeParams) => void): void => {
      this.addListenerFn(FORM_EVENTS.GEO_TARGET_CHANGE, listenerId, fn)
    },
    formOpened: (listenerId: string, fn: (form: IForm) => void): void => {
      this.addListenerFn(FORM_EVENTS.FORM_OPENED, listenerId, fn)
    },
    formClosed: (listenerId: string, fn: (form: IForm) => void): void => {
      this.addListenerFn(FORM_EVENTS.FORM_CLOSED, listenerId, fn)
    },
    summaryOpened: (listenerId: string, fn: (form: IForm) => void): void => {
      this.addListenerFn(FORM_EVENTS.SUMMARY_OPENED, listenerId, fn)
    },
    summaryClosed: (listenerId: string, fn: (form: IForm) => void): void => {
      this.addListenerFn(FORM_EVENTS.SUMMARY_CLOSED, listenerId, fn)
    }
  }
}

export const formEventModule: FormEventModule = new FormEventModule()
